<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      data: {
        access_token: this.$route.query.access_token,
        refresh_token: this.$route.query.refresh_token
      }
    };
  },
  created: function() {
    console.log("created");

    const { access_token, refresh_token } = this.data;
    console.log(this.$route.query);
    console.log("created");

    this.$store.dispatch("auth", { access_token, refresh_token });
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    }
  }
};
</script>

<style></style>
